(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('axios'), require('lodash'), require('url-join')) :
    typeof define === 'function' && define.amd ? define(['axios', 'lodash', 'url-join'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.OtWhitelabels = factory(global.axios, global.lodash, global.urljoin));
})(this, (function (axios, lodash, urljoin) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
    var urljoin__default = /*#__PURE__*/_interopDefaultLegacy(urljoin);

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    class WhitelabelResources {
        constructor(baseUrl) {
            this._baseUrl = baseUrl;
        }
        get icon() {
            return urljoin__default["default"](this._baseUrl, "graphics/icon.svg");
        }
        get iconDark() {
            return urljoin__default["default"](this._baseUrl, "graphics/icon_dark.svg");
        }
        get logo() {
            return urljoin__default["default"](this._baseUrl, "graphics/logo.svg");
        }
        get logoDark() {
            return urljoin__default["default"](this._baseUrl, "graphics/logo_dark.svg");
        }
        get spinner() {
            return urljoin__default["default"](this._baseUrl, "graphics/spinner.gif");
        }
        get spinnerDark() {
            return urljoin__default["default"](this._baseUrl, "graphics/spinner_dark.gif");
        }
        get favicon() {
            return urljoin__default["default"](this._baseUrl, "graphics/favicon.png");
        }
        get stylesheet() {
            return urljoin__default["default"](this._baseUrl, "style.css");
        }
        get iconPack() {
            return "\"https://cdn.openticket.tech/icons/v0.8.5/ot-icons.css\";";
        }
    }

    /**
     * Helper to load the whitelabel configuration and do some common tasks
     * that are required when implementing whitelabel support.
     */
    class Whitelabel {
        constructor(config = {}) {
            this.initialized = false;
            if (!config.url) {
                if (!config.whitelabel) {
                    /*
                    * We absolutely assume only simple domains here (.nl,.io.. etc) .co.uk will fail
                    * a proper fix is probably https://stackoverflow.com/a/32263695/2892455 but
                    * is a whole lot of code, this will suffice for now, and failure mode
                    * is clear enough (whole shop will fail to load)
                    */
                    const getRootDomainFromHostName = (inputUrl) => inputUrl
                        .split('.')
                        .slice(-2)
                        .join('.');
                    // Get root domain from hostname
                    config.whitelabel = getRootDomainFromHostName(config.hostname || window.location.hostname);
                }
                config.url = urljoin__default["default"]("https://cdn.openticket.tech/whitelabels/", config.whitelabel);
            }
            if (!config.http) {
                config.http = axios__default["default"].create();
            }
            this._config = config;
            this.resources = new WhitelabelResources(config.url);
            if (config.data) {
                this._init(config.data);
            }
        }
        /**
         * Async init for receiving a whitelabel instance from different kinds of
         * environments.
         * @param config configuration for requesting the whitelabel files
         * @returns whitelabel instance
         */
        init() {
            return __awaiter(this, void 0, void 0, function* () {
                const { data } = yield this._config.http.get(urljoin__default["default"](this._config.url, "config.json"));
                this._init(data);
            });
        }
        _init(data) {
            this._original = data;
            this.name = data.name;
            this.website_url = data.website_url;
            this.shop = Object.assign({}, data.shop);
            this.order = Object.assign({}, data.order);
            this.locales = data.locales || {};
            this.initialized = true;
        }
        /**
         * Set the locale for the whitelabel configuration, overwrites some properties
         * if locale specific options are available
         * @param locale locale string
         */
        setLocale(locale) {
            const obj = lodash.merge({}, this._original, this.locales[locale] || {});
            this._setProps(obj);
        }
        /**
         * Add whitelabel stylesheet to document head.
         */
        loadStylesheet() {
            return new Promise((resolve, reject) => {
                const { head } = document;
                const link = document.createElement('link');
                link.type = 'text/css';
                link.rel = 'stylesheet';
                link.onload = () => resolve();
                link.onerror = () => reject();
                link.href = this.resources.stylesheet;
                head.insertAdjacentElement('afterbegin', link);
            });
        }
        loadIconPack() {
            return new Promise((resolve, reject) => {
                const { head } = document;
                const link = document.createElement('link');
                link.type = 'text/css';
                link.rel = 'stylesheet';
                link.onload = () => resolve();
                link.onerror = () => reject();
                link.href = this.resources.iconPack;
                head.insertAdjacentElement('afterbegin', link);
            });
        }
        setFavicon() {
            return new Promise((resolve, reject) => {
                const link = document.createElement('link');
                link.rel = 'shortcut icon';
                link.type = 'image/png';
                link.onload = () => resolve();
                link.onerror = () => reject();
                link.href = this.resources.favicon;
                document.head.appendChild(link);
            });
        }
        _setProps(config) {
            var _a, _b, _c, _d, _e, _f;
            if (config === null || config === void 0 ? void 0 : config.name) {
                this.name = config.name;
            }
            if (config === null || config === void 0 ? void 0 : config.website_url) {
                this.website_url = config.website_url;
            }
            if ((_a = config === null || config === void 0 ? void 0 : config.shop) === null || _a === void 0 ? void 0 : _a.url) {
                this.shop.url = config.shop.url;
            }
            if ((_b = config === null || config === void 0 ? void 0 : config.order) === null || _b === void 0 ? void 0 : _b.support_email) {
                this.order.support_email = config.order.support_email;
            }
            if ((_c = config === null || config === void 0 ? void 0 : config.shop) === null || _c === void 0 ? void 0 : _c.gtm_code) {
                this.shop.gtm_code = config.shop.gtm_code;
            }
            if ((_d = config === null || config === void 0 ? void 0 : config.shop) === null || _d === void 0 ? void 0 : _d.facebook_client_id) {
                this.shop.facebook_client_id = config.shop.facebook_client_id;
            }
            if ((_e = config.order) === null || _e === void 0 ? void 0 : _e.ticketswap_resell_url) {
                this.order.ticketswap_resell_url = config.order.ticketswap_resell_url;
            }
            if ((_f = config.order) === null || _f === void 0 ? void 0 : _f.tixel_resell_url) {
                this.order.tixel_resell_url = config.order.tixel_resell_url;
            }
        }
    }

    return Whitelabel;

}));
